import { type ToastContainerProps } from "react-toastify";

export const toastContainerProps: ToastContainerProps = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "light",
  pauseOnFocusLoss: false,
  newestOnTop: true,
  limit: 3,
};
